// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles-module--overlay--1tg65"};